import { AnonymousProfile, ProfileService } from '../types/Profile';

// 랜덤 닉네임 후보들
const RANDOM_ADJECTIVES = [
  '행복한', '즐거운', '멋진', '귀여운', '용감한', '똑똑한', '친절한', '재미있는',
  '활발한', '차분한', '신비한', '빛나는', '따뜻한', '시원한', '달콤한', '상쾌한',
  '화려한', '고요한', '자유로운', '건강한', '평화로운', '유쾌한', '특별한', '소중한'
];

const RANDOM_NOUNS = [
  '토끼', '고양이', '강아지', '판다', '코알라', '돌고래', '나비', '무지개',
  '별', '달', '해', '구름', '꽃', '나무', '바다', '산',
  '케이크', '아이스크림', '쿠키', '사탕', '초콜릿', '과일', '커피', '차'
];

// 이모지 아바타 후보들
const AVATAR_EMOJIS = [
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🥲',
  '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰',
  '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜',
  '🤪', '🤨', '🧐', '🤓', '😎', '🥸', '🤩', '🥳',
  '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️',
  '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤',
  '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱'
];

// 그라데이션 색상 조합
const GRADIENT_COLORS = [
  'from-purple-400 to-pink-400',
  'from-blue-400 to-purple-500',
  'from-green-400 to-blue-500', 
  'from-yellow-400 to-orange-500',
  'from-pink-400 to-red-500',
  'from-indigo-400 to-purple-500',
  'from-teal-400 to-blue-500',
  'from-orange-400 to-pink-500',
  'from-cyan-400 to-blue-500',
  'from-lime-400 to-green-500'
];

const STORAGE_KEY = 'anonymous_profile';

class AnonymousProfileService implements ProfileService {
  getProfile(): AnonymousProfile | null {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('프로필 로드 실패:', error);
      return null;
    }
  }

  generateRandomProfile(): AnonymousProfile {
    const adjective = RANDOM_ADJECTIVES[Math.floor(Math.random() * RANDOM_ADJECTIVES.length)];
    const noun = RANDOM_NOUNS[Math.floor(Math.random() * RANDOM_NOUNS.length)];
    const displayName = `${adjective} ${noun}`;
    
    const avatarColor = GRADIENT_COLORS[Math.floor(Math.random() * GRADIENT_COLORS.length)];
    const avatarEmoji = AVATAR_EMOJIS[Math.floor(Math.random() * AVATAR_EMOJIS.length)];
    
    const profile: AnonymousProfile = {
      id: this.generateId(),
      displayName,
      avatarColor,
      avatarEmoji,
      createdAt: new Date().toISOString()
    };

    this.saveProfile(profile);
    return profile;
  }

  updateProfile(updates: Partial<Omit<AnonymousProfile, 'id' | 'createdAt'>>): void {
    const currentProfile = this.getProfile();
    if (!currentProfile) {
      throw new Error('업데이트할 프로필이 없습니다.');
    }

    const updatedProfile = {
      ...currentProfile,
      ...updates
    };

    this.saveProfile(updatedProfile);
  }

  clearProfile(): void {
    localStorage.removeItem(STORAGE_KEY);
  }

  private saveProfile(profile: AnonymousProfile): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
    } catch (error) {
      console.error('프로필 저장 실패:', error);
    }
  }

  private generateId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }
}

export const profileService = new AnonymousProfileService();